// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"c573d947","615":"437a0fac","770":"cbb90a2c"}[chunkId] + ".chunk.js";
};